// Scroll motion for Kakahuette landing sections. No dependencies.
//   [data-reveal]          fades and rises in when it enters the viewport; --i on children staggers them
//   [data-count="949"]     counts up from 0 when visible (keeps any prefix/suffix in data-count-suffix)
//   [data-parallax="0.15"] drifts against the scroll by that factor
// Everything is skipped when the visitor prefers reduced motion.

const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

function reveal(root) {
  const items = root.querySelectorAll('[data-reveal]:not(.is-in)');
  if (reduced || !('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('is-in'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -12% 0px' },
  );
  items.forEach((el) => io.observe(el));
}

function counters(root) {
  const items = root.querySelectorAll('[data-count]');
  const format = (n) => Math.round(n).toLocaleString('en-GB');
  const run = (el) => {
    const target = Number(el.dataset.count);
    const suffix = el.dataset.countSuffix ?? '';
    if (reduced) {
      el.textContent = format(target) + suffix;
      return;
    }
    const start = performance.now();
    const step = (now) => {
      const t = Math.min(1, (now - start) / 1400);
      el.textContent = format(target * (1 - (1 - t) ** 3)) + suffix;
      if (t < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  if (!('IntersectionObserver' in window)) return items.forEach(run);
  const io = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      run(entry.target);
      io.unobserve(entry.target);
    }
  });
  items.forEach((el) => io.observe(el));
}

function parallax(root) {
  if (reduced) return;
  const items = [...root.querySelectorAll('[data-parallax]')];
  if (!items.length) return;
  let frame = 0;
  const update = () => {
    frame = 0;
    const vh = innerHeight;
    for (const el of items) {
      const rect = el.parentElement.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) continue;
      const progress = (rect.top + rect.height / 2 - vh / 2) / vh;
      el.style.transform = `translate3d(0, ${(progress * Number(el.dataset.parallax) * 100).toFixed(2)}px, 0)`;
    }
  };
  addEventListener('scroll', () => (frame ||= requestAnimationFrame(update)), { passive: true });
  addEventListener('resize', () => (frame ||= requestAnimationFrame(update)));
  update();
}

function init(root = document) {
  reveal(root);
  counters(root);
  parallax(root);
}

init();
document.addEventListener('shopify:section:load', (event) => init(event.target));
